import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { Image, H4, P, H3 } from '../../../AbstractElements';
import { CompanyEmail, CompanyName, CompanyPhone, Invoice, InvoiceNumber, Issued, IssuedDate, June, May, PaymentDue, PaymentDueDate } from '../../../Constant';

import logo from '../../../assets/images/logo/logo-icon.png';
import CountUp from 'react-countup';
const InvoiceHeader = () => {
  return (
    <Row className='invo-header'>
      <Col sm='6'>
        <div className='d-flex'>
          <div className='d-flex-left'>
            <Link to={`${process.env.PUBLIC_URL}/dashboard/default`}>
              <Image className='d-flex-object img-60' src={logo} alt='' />
            </Link>
          </div>
          <div className='flex-grow-1 m-l-20'>
            <H4 className='d-flex-heading f-w-600'>{CompanyName}</H4>
            <P>
              {CompanyEmail}
              <br />
              <span className='digits'>{CompanyPhone}</span>
            </P>
          </div>
        </div>
      </Col>
      <Col sm='6'>
        <div className='text-md-end text-xs-center'>
          <H3>
            {Invoice} #
            <span className='digits counter'>
              <CountUp end={InvoiceNumber} />
            </span>
          </H3>
          <P>
            {Issued}: {May}
            <span className='digits'>{IssuedDate}</span>
            <br />
            {PaymentDue}: {June} <span className='digits'>{PaymentDueDate}</span>
          </P>
        </div>
      </Col>
    </Row>
  );
};

export default InvoiceHeader;
